import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/live/arthaverse-website/components/modules/professionals/connectButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfessionalAbout"] */ "/home/ubuntu/live/arthaverse-website/components/modules/professionals/professionalAbout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfessionalTestimonials"] */ "/home/ubuntu/live/arthaverse-website/components/modules/professionals/professionalTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileAvatar"] */ "/home/ubuntu/live/arthaverse-website/components/modules/professionals/profileAvatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/live/arthaverse-website/components/modules/professionals/requestServiceButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/home/ubuntu/live/arthaverse-website/components/modules/professionals/shareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/live/arthaverse-website/components/modules/resources/professionalArticle.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/live/arthaverse-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/live/arthaverse-website/node_modules/next/dist/client/image-component.js");
